export default __webpack_public_path__ + "static/media/slide3.dbd348c3.jpg";